// import { Agent } from '../_models/agent';

export class AuxFunction {

    hashList: any[];

    actionModal: boolean;
    alertModal: boolean;
    infoModal: boolean;

    actionInfo: string;
    alertInfo: string;
    infoInfo: string;

    contentCSV: any;
    contentSheetCSV: any;
    contentFileCSV: any;

    sheetList: any;
    traverseList: any;
    pieceList: any;

    nextSheet: any;
    nextTraverse: any;
    nextPiece: any;

    kg_m2: number;

 constructor() {
   this.kg_m2 = 2.5;
   this.contentCSV = [];
 }

 // Función que pasándole un listado de elmentos "listIn", encuentra el elemento cuyo campo "field1"
 // coincide con el valor "idIn" y devuelve el valor del campo "field2" de ese elemento encontrado.
 // Es útil para obtener nombres de elementos de una tabla según su ID.
 getTypeNameOfList(idIn: any, listIn: any[], field1In: string, field2In: string): string {
    // console.log('getTypeNameOfList -> Campo ' + field1In + ' para el valor = ' + idIn);

    let groupAux;
    let name = '---';

    if (listIn && idIn !== null && idIn !== undefined) {
      groupAux = listIn.find(item => {
        if (item[field1In] !== null && item[field1In] !== undefined && idIn.toString() === item[field1In].toString()) {
          return true;
        } else {
          return false;
        }
      });

      if (groupAux !== null && groupAux !== undefined) {

        name = groupAux[field2In];

        if (groupAux.active !== null && groupAux.active !== undefined) {
          if (groupAux.active !== true) {
            name = name + ' (no activo)';
          }
        }
      }
    }

    return name;
 } // End function getTypeNameOfList

 getStringName(idIn: any): string {
    // console.log('getStringName -> para el valor = ' + idIn);

    if (idIn !== null && idIn !== undefined) {
        return this.hashList[idIn];
    } else {
        return '---';
    }
 } // End function getStringName

 setHashList(listIn: any[], keyIn: string, valueIn: string) {
    //  console.log('setHashList -> Clave ' + keyIn + ' ; Valor = ' + valueIn);
    //  console.log(listIn);

     this.hashList = [];

     listIn.forEach(item => {
        this.hashList[item[keyIn]] = item[valueIn];
     });

 } // End function setHashList


 // --------------------------------------------
 //       FUNCIONES PARA ARCHIVOS
 // --------------------------------------------

  // Función que sirve para descsagar el contenido de un archivo de texto o CSV.
  downloadFile(data: any) {
    // console.log('--> AuxFunction downloadFile: Descargndo archivo...');
    // console.log(data);

    const blob = new Blob([data], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    // console.log('--> downloadFile nombre archivo:');
    // console.log(url);

    // NOTA: Para obtener el nombre aleatorio que se le ha asignado al archivo de descarga.
    // let name = url.split('/');
    // console.log(name[name.length - 1]);

    window.open(url);
  } // End function downloadFile

  // Función que lee el archivo seleccionado en el "input" de tipo "file" del html.
  async onFileSelect(input: HTMLInputElement) {

    // IMPORTANTE: Uso de "that" para representar al "this" interno de esta función.
    // Se usa para poder usarlo a su vez dentro de otra función anidada, como se ve más abajo.
    let that = this;

    console.log(' -> * AuxFunction onFileSelect...');
    console.log(input);
    console.log(input.files);

    // let pahtIn = URL.createObjectURL(input.files[0]);
    // console.log(pahtIn);

    // this.contentCSV = [];

    const files = input.files;
    const fileReader = new FileReader();

    let filename = null;
    let type = null;
    let size = null;

    if (files[0]) {
      filename = files[0].name;
      type = files[0].type;
      size = files[0].size;
    }

    if (files && files.length) {

      console.log('Filename: ' + files[0].name);
      console.log('Type: ' + files[0].type);
      console.log('Size: ' + files[0].size + ' bytes');

      const fileToRead = files[0];

      // Primero hay que leer el archivo, en este caso en modo texto.
      fileReader.readAsText(fileToRead, 'UTF-8');

      // fileReader.onload = function() {

      // };

      // Cuando se carga el archivo por el evento "onload" se ejecuta la función "onFileLoad"
      // la cual está declarada arriba dentro de la función "onFileSelect".
      // fileReader.onload = this.onFileLoad;

      // Para lanzar una acción cuando termina de leer el archivo.
      fileReader.onloadend = await function() {

        // IMPORTANTE: Uso de "that" para tener el valor de "this" dentro de esta declaración de función anidada.
        that.contentCSV = that.csvToJson(fileReader.result);

        // console.log('-> onloadend contentCSV:');
        // console.log(that.contentCSV);
      };
    }

    // this.contentCSV = fileReader.result;

    // console.log('--> -> onFileSelect contentCSV:');
    // console.log(this.contentCSV);

    // console.log('--> -> onFileSelect fileReader.result:');
    // console.log(fileReader.result);

    return { filename: filename, type: type, size: size };

  } // End function onFileSelect

  // Función que lee los archivos seleccionados a la vez en el "input" de tipo "file" del html.
  async onMultipleFileSelect(input: HTMLInputElement, type_content: string) {

    console.log(' -> * AuxFunction onMultipleFileSelect...');
    console.log(input);
    console.log(input.files);

    // IMPORTANTE: Uso de "that" para representar al "this" interno de esta función.
    // Se usa para poder usarlo a su vez dentro de otra función anidada, como se ve más abajo.
    let that = this;

    // Se vacía el contenido guardado en el almacén de información de archivos CSV.
    // NOTA: Ya no se vacía porque se van a ir acumulando archivos para poder cargarlos en tandas.
    // that.contentCSV = [];

    let resultFileList = [];

    const files = input.files;

    for (let i = 0; i < files.length; i++) {

      console.log('Filename [' + i + ']: ' + files[i].name);
      console.log('Type[' + i + ']: ' + files[i].type);
      console.log('Size[' + i + ']: ' + files[i].size + ' bytes');

      let filename = files[i].name;
      let type = files[i].type;
      let size = files[i].size;

      const fileReader = new FileReader();

      const fileToRead = files[i];

      // Primero hay que leer el archivo, en este caso en modo texto.
      fileReader.readAsText(fileToRead, 'UTF-8');

      // fileReader.onload = function() {

      // };

      // Cuando se carga el archivo por el evento "onload" se ejecuta la función "onFileLoad"
      // la cual está declarada arriba dentro de la función "onFileSelect".
      // fileReader.onload = this.onFileLoad;

      // Para lanzar una acción cuando termina de leer el archivo.
      fileReader.onloadend = await function() {

        // IMPORTANTE: Uso de "that" para tener el valor de "this" dentro de esta declaración de función anidada.
        // that.contentCSV = that.csvToJson(fileReader.result);

        if (!that.contentCSV) {
          that.contentCSV = [];
        }

        resultFileList.push({ filename: filename, type: type, size: size });

        console.log(' -> * AuxFunction onMultipleFileSelect resultFileList:');
        console.log(resultFileList);

        that.contentCSV.push(
          { filename: filename,
            type: type,
            size: size,
            content: that.csvToJson(fileReader.result),
            type_content: type_content,
            checked: true
          });

        // console.log('-> onloadend contentCSV:');
        // console.log(that.contentCSV);
      };
    } // End For files.

    // NOTA: si se intenta mostrar aquí el contenido de contentCSV aparecerá como "undefined"
    // aunque luego posteriormente realmente esta variable va a tener el contenido calculado.
    // console.log(' -> * AuxFunction onMultipleFileSelect contentCSV:');
    // console.log(that.contentCSV);

    // return { filename: filename, type: type, size: size };
    return resultFileList;

  } // End function onMultipleFileSelect

  // Función que transforma el contenido de un archivo CSV en una variable JSON.
  csvToJson(textIn: any): any {

    const csv = [];
    const csvSeparator = ';';

    // NOTA: Si estamos seguro que el csv siempre va a venir sin comillas y sin retornos de carro \r
    // entonces se descomenta esta línea y se comenta las líneas de abajo que hacen los reemplazos.
    // const txt = textFromFileLoaded;

    // Expresión regular que encuentra todos los "retornos de carro" (\r) dentro de un fichero de texto.
    // gi indica g de "global" para que busque todos, e "i" de incondicional para que no importe mayúsculas o minúsculas.
    const re1 = /\r/gi;
    const re2 = /"/gi;

    // Cada vez que encuentre la expresión regular la sustituye por nada (la quita).
    let txt = textIn.replace(re1, '');
    txt = txt.replace(re2, '');

    const lines = txt.split('\n');
    lines.forEach(element => {
      const cols: string[] = element.split(csvSeparator);
      csv.push(cols);
    });

    // console.log(' -> * AuxFunction csvToJson resultado JSON:');
    // console.log(csv);

    return csv;
  } // End function csvToJson

  // Función interna que guarda en una matriz el contenido del csv (filas y columnas).
  // Devuelve un JSON con el contido del CSV.
  onFileLoad(fileLoadedEvent) {

    console.log(' -> * AuxFunction onFileLoad result:');
    console.log(fileLoadedEvent.target.result);

  } // End function onFileLoad.

  // Devuelve un array con el contenido de todos los archivos de un tipo concreto
  // que existe en el "almacen" de archivos guardados (variable contentCSV).
  getContentCSV(type_content: string) {

    console.log('--> - AuxFunction getContentCSV type_content: ' + type_content);
    // console.log(this.contentCSV);

    let files_required = this.contentCSV.filter(f => f.type_content === type_content);

    let content_required = [];

    files_required.forEach(c => {
      content_required.push(c.content);
    });

    console.log('--> - AuxFunction getContentCSV content_required:');
    console.log(content_required);

    return content_required;
  }

  getFilesCSV(type_content: string) {

    console.log('--> - AuxFunction getFilesCSV type_content: ' + type_content);
    // console.log(this.contentCSV);

    let files_required = this.contentCSV.filter(f => f.type_content === type_content);


    console.log('--> - AuxFunction getFilesCSV content_required:');
    console.log(files_required);
    // console.log(files_required);

    return files_required;
  }

  setContentCSV(valueIn: any) {

    console.log('--> - AuxFunction setContentCSV:');
    // console.log(valueIn);

    this.contentCSV = valueIn;

    // console.log('--> - setContentCSV contentCSV:');
    // console.log(this.contentCSV);
  }

  clearContentCSV(type_content) {

    console.log('--> - AuxFunction clearContentCSV: ' + type_content);
    // console.log(this.contentCSV);

    if (type_content === 'all') {
      this.contentCSV = [];
    } else if (type_content !== null && type_content !== undefined && type_content !== '') {
      this.contentCSV = this.contentCSV.filter(f => f.type_content !== type_content);
    }
  }

  // -------------------------
  //  FUNCIONES DE BLOQUEO
  // -------------------------
  blockElement(permisionIn: string, keyIn: string, blockedList: any) {

    console.log('--> - AuxFunction blockElement: ' + keyIn);
    console.log(blockedList);
    console.log(permisionIn);
    console.log(blockedList.includes(keyIn));

    if (blockedList.includes(keyIn) && permisionIn !== 'SuperAdmin') {
      console.log('- Bloqueado elemento con key = ' + keyIn);

      return true;
    }

    return false;

  } // End function blockElement

  blockElementByGeneralParameter(permisionIn: string, keyIn: string, blockedList: any) {

    console.log('--> - AuxFunction blockElementByGeneralParameter: ' + keyIn);
    console.log(blockedList);

    let blocked = null;

    if (blockedList && blockedList.length > 0) {
      blocked = blockedList.find(b =>
                b.setup_type === 'block' &&
                b.setup_key === 'opti_save' &&
                b.setup_value === 'true' &&
                b.setup_value.includes('keyIn') &&
                permisionIn !== 'SuperAdmin');

      console.log('-> Encontrado elemento para blequear:');
      console.log(blocked);

    } else {
      console.log('-> Lista de parámetro de bloque vacía.');
    }

    if (blocked) {
      return true;
    }

    return false;

  } // End function blockElementByGeneralParameter

  // -------------------------
  //  FUNCIONES DE ORDENACIÓN
  // -------------------------

  // Función para la ordenación elementos teniendo en cuenta el número de "secuencia" del elemento.
  orderBySequence(arrayIn: any[]) {

    // console.log(' --> -> orderBySequence entrada:');
    // console.log(arrayIn);

    // Es menor el elemento cuya multiplicación de "ancho x alto" sea más pequeña.
    return arrayIn.sort((a, b) => {

      // let aDimension = a['max_width'] * a['max_height'];
      // let bDimension = b['max_width'] * b['max_height'];

      // console.log('--> a = ' + a.stockwidth + ' x ' + a.stockheight + ' = ' + aDimension);
      // console.log('--> b = ' + b.stockwidth + ' x ' + b.stockheight + ' = ' + bDimension);

      let compare = 0;

      if (a['max_width'] < b['max_width']) {
        // console.log('--> A < B por anchura.');
        compare = -1;
      } else if (a['max_width'] > b['max_width']) {
        // console.log('--> A > B por anchura.');
        compare = 1;
      } else { // Tienen el mismo ancho. Se compara el alto entonces.
        if (a['max_height'] < b['max_height']) {
          // console.log('--> A < B por altura.');
          compare = -1;
        } else if (a['max_height'] > b['max_height']) {
          // console.log('--> A > B por altura.');
          compare = 1;
        } else {
          // console.log('--> A y B tienen las mismas dimensiones.');
          compare = 0; // Son iguales.
        }
      }

      return compare;
    });

  } // End function orderBySequence

  // Función para la ordenación elementos teniendo en cuenta las dimensiones del elemento.
  orderEaselByDimension(arrayIn: any[]) {

    // console.log(' --> -> orderEaselByDimension entrada:');
    // console.log(arrayIn);

    // Es menor el elemento cuya multiplicación de "ancho x alto" sea más pequeña.
    return arrayIn.sort((a, b) => {

      // let aDimension = a['max_width'] * a['max_height'];
      // let bDimension = b['max_width'] * b['max_height'];

      // console.log('--> a = ' + a.stockwidth + ' x ' + a.stockheight + ' = ' + aDimension);
      // console.log('--> b = ' + b.stockwidth + ' x ' + b.stockheight + ' = ' + bDimension);

      let compare = 0;

      if (a['max_width'] < b['max_width']) {
        // console.log('--> A < B por anchura.');
        compare = -1;
      } else if (a['max_width'] > b['max_width']) {
        // console.log('--> A > B por anchura.');
        compare = 1;
      } else { // Tienen el mismo ancho. Se compara el alto entonces.
        if (a['max_height'] < b['max_height']) {
          // console.log('--> A < B por altura.');
          compare = -1;
        } else if (a['max_height'] > b['max_height']) {
          // console.log('--> A > B por altura.');
          compare = 1;
        } else {
          // console.log('--> A y B tienen las mismas dimensiones.');
          compare = 0; // Son iguales.
        }
      }

      return compare;
    });

  } // End function orderEaselByDimension

  // -----------------------------------------------
  //  FUNCIONES PARA EL CONTROL DE VENTANAS MODALES
  // -----------------------------------------------

  showActionModal(value: boolean) {
    console.log('--> - -> AuxFunction: showActionModal = ' + value);

    this.actionModal = value;

  } // End function showActionModal

  // Función que ejecuta una función pasada como parámetro y luego cierra la ventana de confirmación de acción.
  // Para ejecutar la función correctamente se le pasan como parámetros los elementos que se van a necesitar
  // (objetos dentro de su "this") de la clase que está haciendo uso de esta librería.
  confirmActionModal(item: any, arg: any, callback: (element: any | null, aux: any | null) => boolean): any {

    console.log('--> - -> AuxFunction: Confirmada acción del modal.');

    let result = callback(item, arg);

    console.log('--> - -> AuxFunction: Resultado =');
    console.log(result);

    this.showActionModal(false);

    return result;
  } // End function confirmActionModal

  // -------------------------
  //  FUNCIONES DE ORDENACIÓN
  // -------------------------

  // Función para la validación del contenido de un fichero de entrada según una
  // primera columna "guía".
  validateFileFormat(first_column: any[], dataFileIn: any[], element_instance: any): any {

    console.log('--> validateFileFormat first_column:');
    console.log(first_column);
    console.log('--> validateFileFormat dataFileIn:');
    console.log(dataFileIn);
    console.log('--> validateFileFormat element_instance:');
    console.log(element_instance);

    let resultList = [];
    let ok = true;
    let error_msg = '';

    // Comprobación del nombre de las columnas de la primera línea.
    if (dataFileIn && dataFileIn.length > 0) {

      dataFileIn.forEach((archive, j) => {

        let column = '';

        if (archive && archive[0]) {
          column = archive[0];
        }

        console.log('--> validateFileFormat Columna 1 archivo ' + (j + 1));
        console.log(column);

        // Se compara primero que el número de columnas del fichero sea similar.
        // Se parte como ejemplo de la primera fila leída en el fichero de carga.
        if (first_column.length !== column.length) {

          console.log('--> Primera columna NO válida. No coincide en número de columnas en el fichero ' + (j + 1));
          error_msg = 'Primera columna NO válida. No coincide en número de columnas en el fichero ' + (j + 1);
          ok = false;

          return [resultList, error_msg];
        }

        first_column.forEach((c, i) => {

          if (!column.includes(c.nombre)) {

            console.log('--> No se ha encontrado la columna "' + c.nombre + '" en el fichero ' + (j + 1));

            ok = false;

            error_msg = 'Primera columna NO válida. No se ha encontrado la columna "' + c.nombre + '" en el fichero ' + (j + 1);

            return [resultList, error_msg];
          }

        });

        // Se elimina el primer elemento que coincidirá con el nombre de las columnas.
        // archive.shift();

        archive = archive.filter(ar => !ar.includes('Material'));

        archive.forEach( (element, index) => {

          ok = true;

          // console.log('--> - -> Element file:');
          // console.log(element);

          // Las líneas que no tengan el número de columnas correcto no se tratarán.
          if (element.length !== first_column.length) {
            console.log('--> La línea ' + index + ' del fichero tiene un número distinto de campos. No se procesará.');
            ok = false;
          }

          if (element[0] === 'Material') {
            console.log('--> La línea ' + index + ' del fichero tiene los de nombres de columnas. No se procesará.');
            ok = false;
          }

          if (ok) {

            let new_element = JSON.parse(JSON.stringify(element_instance));

            // Asignación de los campos leidos en la línea del archivo a un nuevo elemento.
            first_column.forEach((c, i) => {

              // console.log('--> - -> c columna:');
              // console.log(c);

              switch (c.tipo) {
                case 'numero':

                  new_element[c.campo] = element[i] ? Number(element[i]) : null;

                  break;

                case 'booleano':

                  new_element[c.campo] = element[i] === 'true'  ? true : false;

                  break;

                default:

                  new_element[c.campo] = element[i] ? element[i] : null;

                  break;
              }
            });

            resultList.push(new_element);
          }

        });
      }); // End forEach datafileIn

      console.log('--> validateFileFormat resultList:' + error_msg);
      // console.log(resultList);

      return [resultList, error_msg];

    } // End If dataListIn

  } // End function validateFileFormat
  
  // -------- RELOJ --------
  
  iniciar_crono(thatIn) {
    console.log('--> Cronómetro inicializado...');
    
    thatIn.h = 0;
  	thatIn.m = 0;
  	thatIn.s = 0;
	
	thatIn.cronoModal = true;
	
	document.getElementById("hms").innerHTML="00:00:00";
	
	this.cronometrar(thatIn);
	
  } // End function iniciar_crono.
  
  parar_crono(thatIn) {
    console.log('--> Cronómetro parando...');
	clearInterval(thatIn.crono_id);
	thatIn.cronoModal = false;
	
  } // End function parar_crono.
  
  reiniciar_crono(thatIn, textIn) {
    console.log('--> Cronómetro reiniciando...');
    clearInterval(thatIn.crono_id);
    
    document.getElementById("hms").innerHTML=textIn;
    
    thatIn.h = 0;
  	thatIn.m = 0;
  	thatIn.s = 0;
	
  } // End function reiniciar_crono.
  
  cronometrar(thatIn) {
    console.log('--> Cronómetro: Empieza la cuenta...');
    
    //thatIn.escribir_crono(thatIn);
    
	thatIn.crono_id = setInterval(
		    this.escribir_crono,
		    1000,
		    thatIn // Parámetro para la función "escribir_crono"
	    );
  } // End function cronometrar.
  
  escribir_crono(thatIn){
    console.log('--> Cronómetro: escribiendo en el segundo ' + thatIn.s);
    
    let hAux, mAux, sAux;
    
    thatIn.s++;
    
    if (thatIn.s > 59) {
      thatIn.m++;
      thatIn.s = 0;
    }
    
    if (thatIn.m > 59) {
      thatIn.h++;
      thatIn.m = 0;
    }
    
    if (thatIn.h > 24) {
      thatIn.h = 0;
    }

    if (thatIn.s<10) {
      sAux="0"+thatIn.s.toString();
    } else {
      sAux=thatIn.s.toString();
    }
    
    if (thatIn.m<10) {
      mAux="0"+thatIn.m.toString();
    } else {
      mAux=thatIn.m.toString();
    }
    
    if (thatIn.h<10) {
      hAux="0"+thatIn.h.toString();
    } else {
      hAux=thatIn.h.toString();
    }
  
    // console.log('h = ' + thatIn.h + ' m = ' + thatIn.m + ' s = ' + thatIn.s);
 	// console.log('hAux = ' + hAux + ' mAux = ' + mAux + ' sAux = ' + sAux);

    document.getElementById("hms").innerHTML = hAux + ":" + mAux + ":" + sAux; 
  } // End function escribir_crono.

} // End class AuxFunction